<section class="site-detail-shell">
  <header class="page-header">
    <div>
      <p class="eyebrow">Site workspace</p>
      <h1>{{ site?.name ?? 'Site' }}</h1>
      @if (site) {
        <p class="context-site">Viewing <strong>{{ site.name }}</strong></p>
      }
      <p class="intro">Update the site name, review its content counts, and manage the API keys that belong only to this site.</p>
    </div>
    <div class="header-actions">
      <a class="ghost" routerLink="/sites">Back to sites</a>
      @if (site) {
        <button type="button" class="ghost" (click)="openDashboard()">Open dashboard</button>
        <button type="button" class="ghost" (click)="openLandingPages()">Open landing pages</button>
        <button type="button" class="ghost" (click)="openLinks()">Open links</button>
        <button type="button" class="ghost" (click)="openImages()">Open images</button>
        <button type="button" class="ghost" (click)="openGalleries()">Open galleries</button>
      }
    </div>
  </header>

  @if (error) {
    <p class="error">{{ error }}</p>
  }

  @if (site) {
    <section class="summary-strip" aria-label="Site summary">
      <div class="summary-cell">
        <span>Landing pages</span>
        <strong>{{ site.landingPageCount }}</strong>
      </div>
      <div class="summary-cell">
        <span>API keys</span>
        <strong>{{ site.publicApiKeyCount }}</strong>
      </div>
      <div class="summary-cell">
        <span>Links</span>
        <strong>{{ site.linkCount }}</strong>
      </div>
      <div class="summary-cell">
        <span>Created</span>
        <strong>{{ site.createdAt | date: 'mediumDate' }}</strong>
      </div>
    </section>

    <section class="panel">
      <header class="panel-header">
        <div>
          <p class="eyebrow">Identity</p>
          <h2>Site name</h2>
        </div>
      </header>

      <div class="panel-body">
        <label>
          <span>Name</span>
          <input [(ngModel)]="draftName" placeholder="engineering-docs" />
        </label>

        <div class="panel-actions">
          <button type="button" class="accent" [disabled]="savingName || !draftName.trim()" (click)="saveSiteName()">
            {{ savingName ? 'Saving...' : 'Save name' }}
          </button>
        </div>
      </div>
    </section>

    <section class="panel danger-panel">
      <header class="panel-header">
        <div>
          <p class="eyebrow">Destructive</p>
          <h2>Delete site</h2>
        </div>
      </header>

      <div class="panel-body">
        <p class="panel-copy">Remove this site when it is no longer needed.</p>
        <div class="panel-actions">
          <button type="button" class="danger" [disabled]="deletingSite" (click)="deleteSite()">
            {{ deletingSite ? 'Deleting...' : 'Delete site' }}
          </button>
        </div>
      </div>
    </section>

    <section class="panel">
      <header class="panel-header">
        <div>
          <p class="eyebrow">Provision</p>
          <h2>Create API key</h2>
        </div>
      </header>

      <div class="create-form">
        <label>
          <span>Key label</span>
          <input [(ngModel)]="draftKeyName" placeholder="Public feed consumer" />
        </label>
        <button type="button" class="accent" [disabled]="savingKey || !draftKeyName.trim()" (click)="createKey()">
          {{ savingKey ? 'Creating...' : 'Create key' }}
        </button>
      </div>
    </section>

    <section class="panel">
      <header class="panel-header">
        <div>
          <p class="eyebrow">Registry</p>
          <h2>Issued API keys</h2>
        </div>
        <p class="table-note">{{ loading ? 'Refreshing key inventory...' : 'Delete a key to revoke access for this site.' }}</p>
      </header>

      @if (apiKeys.length) {
        <div class="table-wrap">
          <table>
            <thead>
              <tr>
                <th scope="col">Label</th>
                <th scope="col">API key</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              @for (apiKey of apiKeys; track apiKey.id) {
                <tr>
                  <td class="key-name">{{ apiKey.name }}</td>
                  <td class="key-value-cell"><code class="key-value">{{ apiKey.keyPreview }}</code></td>
                  <td><button type="button" class="danger small" (click)="deleteKey(apiKey)">Delete</button></td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      } @else if (loading) {
        <p class="empty-state">Loading site details.</p>
      } @else {
        <p class="empty-state">No API keys issued for this site yet.</p>
      }
    </section>
  } @else if (loading) {
    <section class="panel">
      <p class="empty-state">Loading site details.</p>
    </section>
  } @else {
    <section class="panel">
      <p class="empty-state">This site could not be loaded.</p>
    </section>
  }
</section>

@if (createdKeyDialog) {
  <div class="dialog-backdrop" (click)="closeCreatedKeyDialog()">
    <section
      class="dialog-panel"
      role="dialog"
      aria-modal="true"
      aria-labelledby="created-api-key-title"
      (click)="$event.stopPropagation()">
      <header class="dialog-header">
        <div>
          <p class="eyebrow">New API key</p>
          <h2 id="created-api-key-title">{{ createdKeyDialog.name }}</h2>
        </div>
        <button type="button" class="ghost small" (click)="closeCreatedKeyDialog()">Close</button>
      </header>

      <p class="panel-copy">Copy this key now. After this dialog is closed, only the masked preview remains visible.</p>

      <label class="latest-key-field">
        <span>API key value</span>
        <input [value]="createdKeyDialog.key" readonly />
      </label>

      @if (copyMessage) {
        <p class="copy-message">{{ copyMessage }}</p>
      }

      <div class="dialog-actions">
        <button type="button" class="accent" (click)="copyCreatedKey()">Copy key</button>
        <button type="button" class="ghost" (click)="closeCreatedKeyDialog()">Done</button>
      </div>
    </section>
  </div>
}
